/* dropdownIndicator.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./dropdownIndicator.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import CloseIcon from '@atlaskit/icon/core/cross-circle';
import CloseIconOld from '@atlaskit/icon/core/migration/cross-circle';
import SearchIconOld from '@atlaskit/icon/core/migration/search';
import SearchIcon from '@atlaskit/icon/core/search';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box } from '@atlaskit/primitives/compiled';
import { components } from '@atlaskit/select';
var styles = {
  customDropdownIndicatorStyles: "_1e0c1txw _80omtlke _1bah1h6o _1bsbzwfg"
};
var CustomDropdownIndicator = function CustomDropdownIndicator(props) {
  var selectProps = props.selectProps;
  var closeIcon = fg('platform-linking-visual-refresh-sllv') ? /*#__PURE__*/React.createElement(CloseIcon, {
    label: ""
  }) : /*#__PURE__*/React.createElement(CloseIconOld, {
    LEGACY_size: "small",
    label: "",
    color: "currentColor"
  });
  var searchIcon = fg('platform-linking-visual-refresh-sllv') ? /*#__PURE__*/React.createElement(SearchIcon, {
    label: ""
  }) : /*#__PURE__*/React.createElement(SearchIconOld, {
    LEGACY_size: "small",
    label: "",
    color: "currentColor"
  });
  return /*#__PURE__*/React.createElement(components.DropdownIndicator, props, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.customDropdownIndicatorStyles,
    onClick: function onClick() {
      if (selectProps.inputValue) {
        selectProps.onInputChange && selectProps.onInputChange('', {
          action: 'input-change',
          prevInputValue: selectProps.inputValue
        });
      }
    }
  }, selectProps.inputValue ? closeIcon : searchIcon));
};
export default CustomDropdownIndicator;